module.exports = __webpack_public_path__ + "static/img/baoxian.636f3ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baoxian.jpg
// module id = CjCO
// module chunks = 1